import { inject } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { SetContextLink } from '@apollo/client/link/context';
import { HttpLink } from 'apollo-angular/http';
import { environment } from 'environments/environment';

export function apolloInitializerMultitech() {
  const httpLink = inject(HttpLink);
  const credentialsLink = new SetContextLink(() => ({ credentials: 'include' }));
  const http = httpLink.create({ uri: environment.graphql_multitech });

  return {
    'multitech-api': {
      link: ApolloLink.from([credentialsLink.concat(http)]),
      cache: new InMemoryCache(),
    },
  };
}
